import { Component, ViewChild } from "@angular/core";
import { BaseComponent } from "../../../../core/component/Base.Component";
import { AgRendererComponent } from "ag-grid-angular";
import { ICellRendererParams, IAfterGuiAttachedParams } from "ag-grid";
import { ImageComponent } from "../../../image/image.component";
import { IXSModalComponent } from "../../../ixsmodal/ixsmodal.component";
import { ModalComponent } from "ng2-bs3-modal";

@Component({
  selector: "image-editor-cell",
  template: `
    <a (click)="viewScreen()" title="Add Image"
      ><i class="fa fa-plus flat-icon"></i
    ></a>
    <a *ngIf="value" (click)="delete()" title="Delete Image"
      ><i class="fa fa-trash flat-icon "></i
    ></a>
    <a *ngIf="value" (click)="Image()" title="Image"
      ><i class="fa fa-image flat-icon"></i
    ></a>
    <ixs-image (valueChange)="imageChanged($event)" #image></ixs-image>

    <modal #viewImage>
      <modal-header [show-close]="false">
        <h4 class="modal-title">View Image</h4>
      </modal-header>
      <modal-body>
        <img
          class="profile-user-img img-responsive img-circle"
          [src]="ImageUrl"
          alt="Image"
          style="height: 140px;width:150px;margin:auto;margin-top:5%;margin-bottom:5%"
        />
      </modal-body>
      <modal-footer [show-default-buttons]="false"> </modal-footer>
    </modal>
  `
})
export class GridImageComponent extends BaseComponent
  implements AgRendererComponent {
  @ViewChild("image") image: ImageComponent;
  @ViewChild("viewImage") viewer: ModalComponent;
  value: any;
  params: ICellRendererParams;
  refresh(params: any): boolean {
    return true;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.value = params.value;
  }
  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {}

  viewScreen() {
    this.image.openImageModal();
  }

  delete() {
    this.image.removePicture();
  }

  imageChanged(event) {
    ;
    this.value = event.value;
    this.params.setValue(event.value);
  }
  ImageUrl = "";
  Image() {
    ;
    this.image.value = this.value;
    this.viewer.open("sm");
    setTimeout(() => {
      this.ImageUrl = this.image.url;
    }, 400);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/grid/editors/image/gridimage.ts